import { GetServerSideProps, NextPage } from 'next'
import React, { useEffect, useState } from 'react'
import { PageLayout } from '@components/PageLayout/PageLayout'
import s from './authPage.module.scss'
import cn from 'classnames'
import { signIn, useSession } from 'next-auth/react'
import { useRouter } from 'next/router'
import { LinksEnum } from '@specs/navigation'
import { AuthVariants } from '@components/Pages/AuthPage/AuthVariants/AuthVariants'
import { CheckEmail } from '@components/Pages/AuthPage/CheckEmail/CheckEmail'
import { getServerProps } from '@components/Pages/AuthPage/ServerProps'

export const getServerSideProps: GetServerSideProps = getServerProps

interface PageProps {
}

const Page: NextPage<PageProps> = ({}) => {
    const router = useRouter()
    const { status } = useSession()
    const [email, setEmail] = useState('')
    const [showCheckEmail, setShowCheckEmail] = useState(false)

    useEffect(() => {
        status === 'authenticated' && router.push(LinksEnum.FEED_POSTS)
    }, [status])

    const sendCodeConfirm = async (code: string) => {
        await signIn('code', { email, code }).then(async (value) => {
            if (!value?.ok) await router.push(LinksEnum.SIGN_IN_ERROR)
        })
    }

    const sendMailHandler = async () => {
        await signIn('email', { email, redirect: false }).then(async (value) => {
            if (value?.error === 'AccessDenied') {
                await router.push(LinksEnum.BANNED)
            }else {
                if (!value?.ok) await router.push(LinksEnum.SIGN_IN_ERROR)
            }
        })
    }

    const emailHandler = () => {
        if (process.env.NEXT_PUBLIC_ENV === 'prod') {
            // @ts-ignore
            ym(92789664, 'reachGoal', 'new-registration-mail')
        }
        sendMailHandler()
        setShowCheckEmail(true)
    }

    return (
        <PageLayout>
            <div className={s.authPage}>
                <div className={cn(s.authPage__container, '_container')}>
                    {showCheckEmail ? (
                        <CheckEmail
                            sendMailHandler={sendMailHandler}
                            sendCodeConfirm={sendCodeConfirm}
                        />
                    ) : (
                        <AuthVariants
                            emailHandler={emailHandler}
                            email={email}
                            setEmail={setEmail}
                        />
                    )}
                </div>
            </div>
        </PageLayout>
    )
}
export default Page
